import React, { useState } from "react";
import "./ExpenseForm.css";

const ExpenseForm = (props) => {
    const [givenTitle, setGivenTitle] = useState("");
    const [givenPrice, setGivenPrice] = useState("");
    const [givenDate, setGivenDate] = useState("");

    const titleChangeHandler = (e) => {
        setGivenTitle(e.target.value);
    };
    const priceChangeHandler = (e) => {
        setGivenPrice(e.target.value);
    };
    const dateChangeHandler = (e) => {
        setGivenDate(e.target.value);
    };

    const submitHandler = (e) => {
        e.preventDefault();

        const expenseData = {
            title: givenTitle,
            amount: givenPrice,
            date: new Date(givenDate),
        };
        props.onSubmitExpenseData(expenseData);

        setGivenTitle("");
        setGivenPrice("");
        setGivenDate("");
    };

    return (
        <form onSubmit={submitHandler}>
            <div className="new-expense__controls">
                <div className="new-expense__control">
                    <label>Title</label>
                    <input
                        type="text"
                        value={givenTitle}
                        onChange={titleChangeHandler}
                    />
                </div>
                <div className="new-expense__control">
                    <label>Price</label>
                    <input
                        type="number"
                        min="0.01"
                        step="0.01"
                        value={givenPrice}
                        onChange={priceChangeHandler}
                    />
                </div>
                <div className="new-expense__control">
                    <label>Date</label>
                    <input
                        type="date"
                        min="2019-01-01"
                        max="2022-12-31"
                        value={givenDate}
                        onChange={dateChangeHandler}
                    />
                </div>
            </div>
            <div className="new-expense__actions">
                <button type="submit">Add Expense</button>
            </div>
        </form>
    );
};

export default ExpenseForm;
